import { ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, UrlSegment } from '@angular/router';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { MapService } from 'src/app/services/map.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { UserService } from 'src/app/services/user.service';

interface modelosVersiones{
  value: string;
  viewValue: string;
}
interface Clientes{
  value: number;
  name: string;
}
interface Estados{
  value: number;
  name: string;
}
interface Establecimientos{
  value: number;
  name: string;
}
@Component({
  selector: 'app-editar-dispositivo',
  templateUrl: './editar-dispositivo.component.html',
  styleUrls: ['./editar-dispositivo.component.css']
})
export class EditarDispositivoComponent implements OnInit, OnChanges, OnDestroy{

  lat: number = 43.0081016;
  lng: number = -7.5561412;
  zoom: number = 14;
  addressData: any;

  etiqueta: string = "";
  descripcion: string = "";
  nSIM: string = "";
  nSerie: string = "";
  searchPlace: string = "";
  file: File | undefined
  imageUrl: string | ArrayBuffer | null = null;
  showImageErrorMessage: boolean = false;
  disabledCheckbox = false;
  version: number | undefined;
  establishmentData: any = []; //Información de los establecimientos y dispositivos
  errorMessage : string =""; //Mensaje de error
  currentPath: string = ""; //Ruta actual
  deviceId: number = 0; //Id del dispositivo que está en la ruta
  disopositivoActual: any = []; //Dispositivos que estamos editando
  dev_img: string = ""; //Imagen del dispositivo
  dev_img_path: string = "";
  tokenSeguridad: string = "";
  numSerie: string = "";
  multitanque: boolean = false;
  usuarioEmail: string = "";
  dataSource :any;
  displayedColumns: string[] = ['email', 'operaciones'];
  configuracionFinalizada: boolean = false;
  map: any; 
  marker: any;

  //AUTOCOMPLETE
  myControl = new FormControl<string | Establecimientos>('');
  filteredOptions!: Observable<Establecimientos[]>;
  establecimientoError: boolean = false;

  usuariosEjemplo: any[] = [
    { id: 1, nombre: 'Juan', email: 'juan@example.com' },
    { id: 2, nombre: 'María', email: 'maria@example.com' },
    { id: 3, nombre: 'Pedro', email: 'pedro@example.com' },
    { id: 4, nombre: 'Laura', email: 'laura@example.com' },
    { id: 5, nombre: 'Carlos', email: 'carlos@example.com' },
    { id: 6, nombre: 'Miguel', email: 'miguel@example.com' },
    { id: 7, nombre: 'Ismel', email: 'ismael@example.com' },
  ];
  showEstadoError: boolean = false;
  dispositivoCreado: boolean = false;
  tiempoEsperaRecarga: number = 60000;
  errorFinal: boolean = false;
  waitAfterSave: boolean = false;
  errorFinalMessage: boolean = false;

  modeloVersion: modelosVersiones[] = [
    {value: 'noImplementado-0', viewValue: 'Sin Implementar'}
  ];
  selectedVersion: string = "";

  estado: Estados[] = [
    {value: 0, name: 'Desactivado'},
    {value: 1, name: 'Activado'}
  ];
  selectedEstado: number = 0;

  establecimientos: Establecimientos[] = [];
  selectedEstablecimiento: number | undefined;

  clientes: Clientes[] = []
  selectedCliente: string = "";
  userData: any = [];

  //Subscriptions
  private establishmentSubscription: Subscription | undefined;
  private clientsSubscription: Subscription | undefined;
  private editarDispositivoSubscription: Subscription | undefined;

  @Input() userId: any;
  
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  constructor(private deviceService: DeviceService, private router: Router, private userDataService: UserDataService,
    private userService : UserService, private error429: Error429Service, private mapService: MapService,
    private cdr: ChangeDetectorRef){
    this.currentPath = this.router.url;
    this.userData = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    //Tabla de usuarios
    this.dataSource = new MatTableDataSource(this.usuariosEjemplo);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

    //Conseguir el id del device del path
    this.deviceId = this.getDeviceIdFromCurrentPath(this.router);

    //Conseguir los clientes
    this.clientsSubscription = this.userService.getClients().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          this.clientes.push({
            value: resp[i].id,
            name: resp[i].razon_social
          });
        }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userId'] && this.userId !== undefined) {
      this.establishmentSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
        next:resp =>{
          this.establishmentData = resp;
          //Lista con establecimientos
          for(let i=0; i<this.establishmentData.length; i++){
            this.establecimientos.push({
              value: this.establishmentData[i].id,
              name: this.establishmentData[i].est_name
            });
          }
          //Dispositivo actual
          for(let i=0; i<this.establishmentData.length; i++){
            for(let j=0; j<this.establishmentData[i].devices.length; j++){
              if(this.establishmentData[i].devices[j].id == this.deviceId){
                this.selectedEstablecimiento = this.establishmentData[i].id;
                this.disopositivoActual = this.establishmentData[i].devices[j];
                this.selectedCliente = this.disopositivoActual.dev_cliente_id;
              }
            }
          }
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        },complete: () =>{
          //Mapa
          //Autocomplete
          const establecimientoSeleccionadoAutocomplete = this.establecimientos.find(establecimiento => establecimiento.value === this.selectedEstablecimiento);
          if (establecimientoSeleccionadoAutocomplete) {
            this.myControl.setValue(establecimientoSeleccionadoAutocomplete);
          }
          this.filteredOptions = this.myControl.valueChanges.pipe(
            startWith(''),
            map(value => {
              const name = typeof value === 'string' ? value : value?.name;
              return name ? this._filter(name as string) : this.establecimientos.slice();
            }),
          );
          const selectedDispositivo: string | Establecimientos | null = this.myControl.value;
          console.log(selectedDispositivo);
          if (selectedDispositivo && typeof selectedDispositivo !== 'string') {
            for(let i = 0; i<this.establishmentData.length; i++){
              if(this.establishmentData[i].id == selectedDispositivo.value){
                this.lat = this.establishmentData[i].est_lat;
                this.lng = this.establishmentData[i].est_lng;
                this.mapService.loadMapScript(this.initMap.bind(this));
                //this.getAddress(this.lat, this.lng);
                //this.marker.setPosition({ lat: this.lat, lng: this.lng });
                //this.map.setCenter({ lat: this.lat, lng: this.lng });
              }
            }
          } else {
            this.establecimientoError = true;
          }
          console.log(this.disopositivoActual);
          this.etiqueta = this.disopositivoActual.dev_label;
          this.descripcion = this.disopositivoActual.dev_description;
          this.tokenSeguridad = this.disopositivoActual.dev_token;
          this.numSerie = this.disopositivoActual.dev_serie;
          this.nSIM = this.disopositivoActual.dev_sim;
          this.version = this.disopositivoActual.dev_version;
          this.selectedEstado = this.disopositivoActual.dev_status;
          if (this.disopositivoActual.locked == 1){
            this.configuracionFinalizada = true;
          } else {
            this.configuracionFinalizada = false;
          }
          /*this.multitanque = this.disopositivoActual.devoptions.multitanque;
          if(this.multitanque = true) {
            this.checkedT1 = this.disopositivoActual.devoptions.t1;
            this.checkedT2 = this.disopositivoActual.devoptions.t2;
            this.checkedT3 = this.disopositivoActual.devoptions.t3;
            this.checkedT4 = this.disopositivoActual.devoptions.t4;
            this.valorTanque1 = this.disopositivoActual.devoptions.cap1;
            this.valorTanque2 = this.disopositivoActual.devoptions.cap2;
            this.valorTanque3 = this.disopositivoActual.devoptions.cap3;
            this.valorTanque4 = this.disopositivoActual.devoptions.cap4;
          }*/
        }
      })
    }
  }

  ngOnDestroy(): void {
    if (this.establishmentSubscription) {
      this.establishmentSubscription.unsubscribe();
    } 
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
    if (this.editarDispositivoSubscription) {
      this.editarDispositivoSubscription.unsubscribe();
    }
  }

  private _filter(name: string): Establecimientos[] {
    const filterValue = name.toLowerCase();

    return this.establecimientos.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  displayFn(establecimiento: Establecimientos): string {
    return establecimiento && establecimiento.name ? establecimiento.name : '';
  }

  initMap(){
    const mapElement = document.getElementById('map');
    // Verificar si el elemento existe antes de intentar trabajar con él
    if (mapElement) {
      const mapOptions = {
        center: { lat: this.lat, lng: this.lng },
        zoom: this.zoom,
      };
      this.map = new google.maps.Map(mapElement, mapOptions);
      this.marker = new google.maps.Marker({
        position: { lat: this.lat, lng: this.lng },
        map: this.map,
        draggable: false,
        title: 'Marcador'
      });
    } else {
      console.error('Elemento del mapa no encontrado en el DOM.');
    }
    this.getAddress(this.lat, this.lng);
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  /*updateEstadoErrorEstablecimiento() {
    //Cambiar la latitud y longitud dependiendo del establecimiento que seleccionemos
    for(let i = 0; i<this.establishmentData.length; i++){
      if(this.establishmentData[i].id==this.selectedEstablecimiento){
        this.lat = this.establishmentData[i].est_lat;
        this.lng = this.establishmentData[i].est_lng;
        this.getAddress(this.lat, this.lng);
        this.marker.setPosition({ lat: this.lat, lng: this.lng });
        this.map.setCenter({ lat: this.lat, lng: this.lng });
      }
    }
    /*Siempre va a haber algún establecimiento seleccionado igual que con el estado asik no es necesario
    manejar el error */
  

  removeEmail(email: string) {
    this.dataSource.data = this.dataSource.data.filter((element: any) => element.email !== email);
  }

  //Función para buscar en la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getDeviceIdFromCurrentPath(router: Router): number {
    const urlTree = router.parseUrl(router.url);
    const segments: UrlSegment[] = urlTree.root.children['primary'].segments;
    // Buscamos el segmento que contiene el número
    let deviceId: number | null = null;
    for (const segment of segments) {
      const value = parseInt(segment.path, 10);
      if (!isNaN(value)) {
        deviceId = value;
        break;
      }
    }
    return deviceId || 0;
  }

  getAddress(latitude: number, longitude: number) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: {lat: latitude, lng: longitude} }).then((response) => {
      //la posicion 0 es el lugar más cercano al click
      if(response.results[0]) {
        this.addressData = response.results[0].formatted_address;
        this.cdr.detectChanges();
      } else{
        window.alert("No hay resultados");
      }
    })
  }

  onFileSelected(event: any) {
    this.file = event.target.files[0];
    console.log(this.file);
    if (this.file && this.file.type === 'image/jpeg') {
      this.previewImage();
      console.log('Archivo seleccionado:', this.file.name);
      this.showImageErrorMessage = false;
    } else {
      this.imageUrl = null;
      this.showImageErrorMessage = true;
      console.log('Por favor, seleccione un archivo .jpg');
    }
    if(this.file == undefined){
      this.showImageErrorMessage = false;
    }
  }

  limpiarSeleccion(): void {
    this.myControl.setValue('');
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.establecimientos.slice();
      }),
    );
  }

  previewImage() {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result;
    };
    reader.readAsDataURL(this.file as Blob);
  }

  //Función para devolver 1 si el valor es true y 0 si es false
  booleanToNumber(value: boolean): number {
    return value ? 1 : 0;
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedDispositivo: string | Establecimientos | null = this.myControl.value;
    console.log(selectedDispositivo);
    if (selectedDispositivo && typeof selectedDispositivo !== 'string') {
      for(let i = 0; i<this.establishmentData.length; i++){
        if(this.establishmentData[i].id == selectedDispositivo.value){
          this.lat = this.establishmentData[i].est_lat;
          this.lng = this.establishmentData[i].est_lng;
          this.getAddress(this.lat, this.lng);
          this.marker.setPosition({ lat: this.lat, lng: this.lng });
          this.map.setCenter({ lat: this.lat, lng: this.lng });
        }
      }
    } else {
      this.establecimientoError = true;
    }
  }

  guardarDispositivo() {
    let configuracionFinalizada;

    //Autocomplete
    const selectedDispositivo: string | Establecimientos | null = this.myControl.value;
    if (selectedDispositivo && typeof selectedDispositivo !== 'string') {
      //El dispositivo ha sido elegido
      this.establecimientoError = false;
    } else {
      this.establecimientoError = true;
    }

    if (this.configuracionFinalizada == false){
      configuracionFinalizada = 0;
    } else {
      configuracionFinalizada = 1;
    }

    if(!this.establecimientoError && selectedDispositivo && typeof selectedDispositivo !== 'string'){
      let dispositivo = {
        _method: "PATCH", 
        id:this.deviceId, 
        label: this.etiqueta, 
        description: this.descripcion, 
        serie: this.numSerie,
        sim: this.nSIM, 
        version_id: this.version,
        cliente_id: this.selectedCliente,
        establishment_id: selectedDispositivo.value.toString() || '', 
        multitanque: this.disabledCheckbox,
        /*t1: this.booleanToNumber(this.checkedT1), 
        t2: this.booleanToNumber(this.checkedT2),
        t3: this.booleanToNumber(this.checkedT3), 
        t4: this.booleanToNumber(this.checkedT4), 
        cap1: this.valorTanque1,
        cap2: this.valorTanque2, 
        cap3: this.valorTanque3, 
        cap4: this.valorTanque4, */
        locked: configuracionFinalizada,
        status: this.selectedEstado
      };
  
      this.editarDispositivoSubscription = this.deviceService.updateDevice(dispositivo).subscribe({
        next:resp => {
        }, error: err =>{
          this.errorMessage = err.error.message;
          console.log(this.errorMessage);
          if(this.errorMessage == undefined){
            this.errorMessage = err.error.error;
            console.log(this.errorMessage);
          }
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.errorFinal = true;
            setTimeout(() => {
              this.errorFinal = false;
              this.waitAfterSave = false;
            },3500)
          }
        }, complete: () =>{
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.dispositivoCreado=true;
            setTimeout(() => {
              this.dispositivoCreado = false;
              this.waitAfterSave = false;
            }, 3500);
          }
        }
      });
    }
  
    /*console.log('Id del dispositivo', this.deviceId);
    console.log('Valor de etiqueta: ', this.etiqueta);
    console.log('Latitud = ', this.lat);
    console.log('Longitud = ', this.lng);
    console.log('Valor de descripcion: ', this.descripcion);
    console.log('Imagen: ', this.file);
    console.log('Token de seguridad ', this.tokenSeguridad);
    console.log('Valor de Nº de serie: ', this.numSerie);
    console.log('Valor de Nº de SIM: ', this.nSIM);
    console.log('Versión del dispositivo',this.version);
    console.log('El cliente seleccionado es: ', this.selectedCliente);
    console.log('Estado: ', this.selectedEstado);
    console.log('Multitanque', this.multitanque);

    console.log('Tanque 1: ', this.checkedT1);
    if(!this.checkedT1){
      this.valorTanque1="";
    }
    console.log('Capacidad Tanque 1 = ', this.valorTanque1);
    console.log('Tanque 2: ', this.checkedT2);
    if(!this.checkedT2){
      this.valorTanque2="";
    }
    console.log('Capacidad Tanque 2 = ', this.valorTanque2);
    console.log('Tanque 3: ', this.checkedT3);
    if(!this.checkedT3){
      this.valorTanque3="";
    }
    console.log('Capacidad Tanque 3 = ', this.valorTanque3);
    console.log('Tanque 4: ', this.checkedT4);
    if(!this.checkedT4){
      this.valorTanque4="";
    }
    console.log('Capacidad Tanque 4 = ', this.valorTanque4);

    console.log('Email del usuario: ', this.usuarioEmail);

    console.log('---------------------------------------');*/
  }

}

